import customErrorMessage from "@/components/CustomErrorMessage";
import { ErrorServices } from "@/services";
import { message } from "antd";

export const handleCsvUpload = async (
  event: React.ChangeEvent<HTMLInputElement>,
  uploadFn: (formData: FormData) => any,
  options?: {
    loadingMessage?: string;
    successMessage?: string;
    onSuccess?: () => void;
  }
) => {
  event.stopPropagation();
  event.preventDefault();

  const file = event.target.files?.[0];
  if (!file) return;

  const isCSV =
    file.type === "text/csv" || file.name.toLowerCase().endsWith(".csv");

  if (!isCSV) {
    customErrorMessage("Only CSV files are allowed.");
    event.target.value = "";
    return;
  }

  const key = "csv-upload";

  try {
    // ✅ NEW: optional loading
    if (options?.loadingMessage) {
      message.loading({
        content: options.loadingMessage,
        key,
        duration: 0,
      });
    }

    const formData = new FormData();
    formData.append("attachment", file, file.name);

    const result = uploadFn(formData);

    if (result?.unwrap) {
      await result.unwrap();
    } else {
      await result;
    }

    // ✅ success (new or fallback)
    if (options?.loadingMessage) {
      message.success({
        content: options?.successMessage || "CSV Data Uploaded Successfully",
        key,
      });
    } else {
      // 🔒 old behavior preserved
      message.success(
        options?.successMessage || "CSV Data Uploaded Successfully"
      );
    }

    options?.onSuccess?.();
  } catch (err: any) {
    if (options?.loadingMessage) {
      message.destroy(key);
    }
    ErrorServices(err);
  } finally {
    event.target.value = "";
  }
};
